import { render } from "./fadeList.vue?vue&type=template&id=cbd73ba4&scoped=true&ts=true"
import script from "./fadeList.vue?vue&type=script&lang=ts"
export * from "./fadeList.vue?vue&type=script&lang=ts"

import "./fadeList.vue?vue&type=style&index=0&id=cbd73ba4&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbd73ba4"]])

export default __exports__